import { Component, ElementRef, ViewChild } from '@angular/core';

import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './url-form-field.component.html',
  styles: [
    `
      .mat-form-field {
        button {
          .mat-icon {
            min-width: 5px;
            width: 18px;
            min-height: 5px;
            height: 18px;
          }
        }
      }

      mat-form-field {
        input {
          &:focus {
            opacity: 1;
          }
        }
      }

      .remove-email-field-url {
        visibility: hidden;
      }
      .url-wrapper:hover .remove-email-field-url {
        visibility: visible;
      }

      .disabled {
        color: #6e6e6e !important;
        pointer-events: none;
        opacity: 0.8;
        cursor: not-allowed !important;
      }

      input.blurred {
        filter: blur(2px);
        font-style: italic;
        letter-spacing: 2px;
      }
    `,
  ],
})
export class UrlFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private _originalValue: string;

  public editing: boolean = false;
  public value: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];

    this._originalValue = this.value;
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  visitUrl(): void {
    window.open(`https://${this.value}`, '_blank');
  }

  updateChangedModel(model: any): void {}

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
